export default __webpack_public_path__ + "static/media/express.eb984af4.jpg";